
//import $ from "jquery";;
import wx, { updateTimelineShareData } from 'weixin-js-sdk';
import router from '../router'
// import axios from './myaxios'





/**用于替代 uni-api */
var uniapi={
	showLoading(){
		showLoading2();
	},
	hideLoading(){
		hideLoading();
	},
	onWindowResize(){

	},
	stopPullDownRefresh(){

	},
	previewImage(img){
		try{
			console.log(img);
			if(typeof img=='object'){
				img=img.urls[img.current];
			}
			if($('#eggsay_img_id').length){
				$('#eggsay_img_id').remove();
			}
			// if(eggsay_img_timeout!=null)clearTimeout(eggsay_img_timeout);
			$('body').append("<div id='eggsay_img_id' class='eggsay_img' style='position:fixed;z-index:9999;"
					+"top:0;bottom:0;left:0;right:0;width:100%;"
					+"color: #fff;background: #222;opacity:1;"
					+"text-align:center;display:flex;justify-content:center;align-items:center;'>"
					+"<img src='"+img+"' style='max-width:var(--h5-max-width);width:100%;'/>"
					+"</div>"
					);
			// eggsay_img_timeout=setTimeout(function(){$('#eggsay_img_id').remove();},5000);
			$('#eggsay_img_id').on('click',function(){$('#eggsay_img_id').remove();});
		}catch(error){console.log(error);}
	},
	scanCode(){

	},
	showModal(obj){

	},
	getImageInfo(obj){

	},
	setNavigationBarTitle(obj){
		document.title = obj.title
	},
	createSelectorQuery(){
		console.log("need do...");
	},
	getStorageSync(key){
		var val = window.localStorage.getItem(key);
		if(!!val==false)return null;
		try {
			if(val.startsWith("[") || val.startsWith("{")){
				var s= JSON.parse(val);
				if(!!s==true) return s;
			}
			var s2= JSON.parse(val);
			if(!!s2==true) return s2;
		} catch (error) {
			console.error(`读取 ${key} 失败:`, error)
		}
		return val;
	},
	setStorageSync(key, val){
		try {
			if(typeof val=='string'){
				window.localStorage.setItem(key, val)
			}else{
				var s= JSON.stringify(val);
				if(s) window.localStorage.setItem(key, s);
			}
		} catch (error) {
			console.error(`转 ${val} 失败:`, error)
		}
		return true
	},
	removeStorageSync(key){
		window.localStorage.removeItem(key);
	},
	getSystemInfoSync(){
		// //使用第三方库
		// npm install ua-parser-js
		// import UAParser from 'ua-parser-js';
		// const parser = new UAParser();
		// const result = parser.getResult();
		// // 获取设备信息
		// console.log(result.os.name);      // 操作系统
		// console.log(result.browser.name); // 浏览器
		// console.log(window.document);  // 设备类型
		return {
			    platform: /android/i.test(navigator.userAgent) ? 'android' : 'ios',
			    system: navigator.platform,
			    screenWidth: window.screen.width, // 获取屏幕尺寸
			    screenHeight: window.screen.height,
			    windowWidth: window.innerWidth, // 返回浏览器窗口的内部宽度（包括滚动条的宽度）。这意味着这个值包括了视口（viewport）的宽度以及垂直滚动条的宽度
			    windowHeight: window.innerHeight,
				clientWidth: document.documentElement.clientWidth, // 返回的是HTML文档的根元素（通常是<html>元素）的视口宽度，不包括垂直滚动条的宽度。
			    clientHeight: document.documentElement.clientHeight,
			    pixelRatio: window.devicePixelRatio,
			    language: navigator.language, // 获取设备语言
				userAgent:navigator.userAgent // 获取用户代理
			};
	},
	
	/**
	 * 
	 * 使用
		if (isMobileDevice()) {
			console.log('移动设备（手机/平板）');
		} else {
			console.log('电脑设备');
		}
	 */
	isMobileDevice() {
		const userAgent = navigator.userAgent.toLowerCase();
		
		// 移动设备关键词
		const mobileKeywords = [
			'mobile', 'android', 'iphone', 'ipod', 'ipad',
			'blackberry', 'windows phone', 'webos',
			'opera mini', 'iemobile', 'kindle', 'silk'
		];
		
		return mobileKeywords.some(keyword => userAgent.includes(keyword));
	},




	/**obj { title:'',icon:"none" } */
	showToast(obj){
		window.alert(obj.title);
	},

	/**
	 * 路由导航（替代 uni.navigateTo() / uni.switchTab()）
	// 跳转到新页面（类似 navigateTo）
	router.push('/page');
	// 替换当前页面
	router.replace('/page');
	// 返回上一页
	router.back();
	*/
	navigateTo(page,params){
 		router.push({path:page,query:params });
	},
	switchTab(page,params){
 		router.push({path:page,query:params });
	},
	navigateBack(){
		router.go(-1);
	},
	redirectTo(obj){
		router.push(obj)
	},
	reLaunch(page,params){
 		// router.push({name:page,query:params });

		// 方式1：普通替换（最接近）
		router.replace('/')

		// 方式2：完全替换（关闭所有页面效果）
		// this.$router.push('/')
		// this.$router.go(0) // 强制刷新页面

		// // 方式3：带参数的替换
		// uni.reLaunch({ url: '/pages/detail?id=123' })
		// // 替换为：
		// this.$router.replace({ path: '/detail', query: { id: 123 } })
	},
	setTabBarBadge (options){
		console.log("需自定义 TabBar 徽章实现");
	},
	removeTabBarBadge(){

	},
	/**剪贴板 API 需要 HTTPS 环境*/
	async setClipboardData(text){
		if(typeof text=='object'){
			text=text.data;
		}
		console.log("kkkkkk",text);
		if(!!text==false){
			alert('内容为空');return;
		}
		// const copyToClipboard = async (text) => {
			try {
				await navigator.clipboard.writeText(text);
				alert('复制成功');
			} catch (err) {
				console.log(err);
				// 降级方案
				//fallbackCopyToClipboard(text);
				alert('复制不成功');
			}
		// };

		// // 降级方案（兼容旧浏览器）
		// const fallbackCopyToClipboard = (text) => {
		// 	const textArea = document.createElement('textarea');
		// 	textArea.value = text;
		// 	document.body.appendChild(textArea);
		// 	textArea.select();
		// 	document.execCommand('copy');
		// 	document.body.removeChild(textArea);
		// 	console.log('复制成功（降级方案）');
		// };
	}

};




/***************xs start*/
var dateUtils = {

	getTimeStr(timestamp){
		if((timestamp+"").length<13)timestamp=timestamp*1000;
		var d=new Date(timestamp);
		var t = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
		+" "+d.getHours()+":"+d.getMinutes()+":"+d.getSeconds();
		return t;
	},
  
	formatTime(time) {
		if (typeof time !== 'number' || time < 0) {
			return time
		}
		var hour = parseInt(time / 3600)
		time = time % 3600
		var minute = parseInt(time / 60)
		time = time % 60
		var second = time

		return ([hour, minute, second]).map(function (n) {
			n = n.toString()
			return n[1] ? n : '0' + n
		}).join(':')
	},

	formatLocation(longitude, latitude) {
		if (typeof longitude === 'string' && typeof latitude === 'string') {
			longitude = parseFloat(longitude)
			latitude = parseFloat(latitude)
		}

		longitude = longitude.toFixed(2)
		latitude = latitude.toFixed(2)

		return {
			longitude: longitude.toString().split('.'),
			latitude: latitude.toString().split('.')
		}
	},

	//毫秒转字符串
	msToStr(ms){
		var s0=ms%1000;
		var miao=((ms-s0)/1000);
		var s=miao%60;
		var m=((miao-s)/60)%60;
		return (m<10?"0"+m:m)+":"+(s<10?"0"+s:s)+":"+(s0<10?("00"+s0):(s0<100?("0"+s0):s0));
	},
	
	/**
	 * 获取年月日 如20220318
	 * @param {Object} date
	 */
	getDateStr(date){
		try{
			if(!!date==false){
				date=new Date();
			}
			return date.getFullYear()
				+(date.getMonth()+1<10?"0":"")+(date.getMonth()+1)
				+(date.getDate()<10?"0":"")+date.getDate();
		}catch(e){
			console.log(e);
		}
	},
	//转换20220318-->2022-03-18
	getDateStrByLine(dateStr){
		if(typeof dateStr!="string")dateStr=dateStr+"";
		if(dateStr.length!=8){
			console.log("日期参数不是8位"+dateStr);
			return dateStr;
		}
		return dateStr.substring(0,4)+"-"+dateStr.substring(4,6)+"-"+dateStr.substring(6,8);
	},
	UNITS: {
		'年': 31557600000,
		'月': 2629800000,
		'天': 86400000,
		'小时': 3600000,
		'分钟': 60000,
		'秒': 1000
	},
	humanize: function (milliseconds) {
		var humanize = '';
		for (var key in this.UNITS) {
			if (milliseconds >= this.UNITS[key]) {
				humanize = Math.floor(milliseconds / this.UNITS[key]) + key + '前';
				break;
			}
		}
		return humanize || '刚刚';
	},
	format: function (dateStr) {
		var date = this.parse(dateStr)
		var diff = Date.now() - date.getTime();
		if (diff < this.UNITS['天']) {
			return this.humanize(diff);
		}
		var _format = function (number) {
			return (number < 10 ? ('0' + number) : number);
		};
		return date.getFullYear() + '/' + _format(date.getMonth() + 1) + '/' + _format(date.getDate()) + '-' +
			_format(date.getHours()) + ':' + _format(date.getMinutes());
	},
	formatMs: function (ms) {
		var date = new Date(ms)
		var diff = Date.now() - date.getTime();
		if (diff < this.UNITS['天']) {
			return this.humanize(diff);
		}
		var _format = function (number) {
			return (number < 10 ? ('0' + number) : number);
		};
		return date.getFullYear() + '/' + _format(date.getMonth() + 1) + '/' + _format(date.getDate()) + '-' +
			_format(date.getHours()) + ':' + _format(date.getMinutes());
	},
	parse: function (str) { //将"yyyy-mm-dd HH:MM:ss"格式的字符串，转化为一个Date对象
		var a = str.split(/[^0-9]/);
		return new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
	}
};


//签名
function sign(url, data) {
  url=url.indexOf("http")==0?getApiPath(url):url;//剔除host

  if (!data.timestamp) {
    data.timestamp = new Date().getTime();
  }
  // if (!data.shopId) {
  //   data.shopId = "1";
  // }
  // if (!data.promoterId) {
  //   var promoterId=wx.getStorageSync('promoterId')||0;
  //   if(!!promoterId==true)data.promoterId = promoterId;
  // }
  // if(typeof data.promoterId=="undefined" || data.promoterId=="undefined")data.promoterId=0;
  
  var str = url;
  var res = Object.keys(data).sort();
  for (var key in res) {
    //console.log("key: " + res[key] + " ,value: " + data[res[key]]);
    if (res[key]=="sign")continue;//避免sign参数
    var value = data[res[key]] + "";//转字符串，避免0识别为空
    if (value != "") {
      str += "&" + res[key] + "=" + value;
    }
  }
  console.log("按key值排序: " + str);
  str = encodeURIComponent(str);
  str = str.replace(/\(/g, "%28");
  str = str.replace(/\)/g, "%29");
  str = str.replace(/\*/g, "%2A");
  str = str.replace(new RegExp("'",'g'), "%27");
  str = str.replace(new RegExp("!",'g'), "%21");
  str = str.replace(new RegExp("~",'g'), "%7E");
  console.log("urlencode: " + str);
  //console.log('key: ', config.signKey);

  //以下md5
  return md5.hex_md5(str + "%26" +  window.$config.signKey);//&==%26

  //以下16进制
  // var sha1_result = CryptoJS.HmacSHA1(str, config.signKey);
  // return sha1_result.toString(CryptoJS.enc.Hex);

  // 以下base64
  // console.log(Base64.encode(byteToString(sha1_result.words)));
  // var base64_res = Base64.encode(byteToString(HexString2Bytes(sha1_result.toString(CryptoJS.enc.Hex))));
  // console.log('sign==', base64_res);
  // return encodeURIComponent(base64_res);
}

//byte[]转str
function byteToString(arr) {
  if (typeof arr === 'string') {
    return arr;
  }
  var str = '',
    _arr = arr;
  for (var i = 0; i < _arr.length; i++) {
    var one = _arr[i].toString(2),
      v = one.match(/^1+?(?=0)/);
    if (v && one.length == 8) {
      var bytesLength = v[0].length;
      var store = _arr[i].toString(2).slice(7 - bytesLength);
      for (var st = 1; st < bytesLength; st++) {
        store += _arr[st + i].toString(2).slice(2);
      }
      str += String.fromCharCode(parseInt(store, 2));
      i += bytesLength - 1;
    } else {
      str += String.fromCharCode(_arr[i]);
    }
  }
  return str;
}


//16转byte[]
function HexString2Bytes(str) {
  var pos = 0;
  var len = str.length;
  if (len % 2 != 0) {
    return null;
  }
  len /= 2;
  var arrBytes = new Array();
  for (var i = 0; i < len; i++) {
    var s = str.substr(pos, 2);
    var v = parseInt(s, 16);
    arrBytes.push(v);
    pos += 2;
  }
  return arrBytes;
}

//16转2
function hex_to_bin(str) {
  let hex_array = [
	  { key: 0, val: "0000"  }, {    key: 1, val: "0001"  }, {    key: 2, val: "0010"  }, 
	  {    key: 3, val: "0011"  }, {    key: 4, val: "0100"  }, {    key: 5, val: "0101"  }, {    key: 6, val: "0110"  }, 
	  {    key: 7, val: "0111"  },  {    key: 8, val: "1000"  }, {    key: 9, val: "1001"  }, {    key: 'a', val: "1010"  },
	  {    key: 'b', val: "1011"  }, {    key: 'c', val: "1100"  }, {    key: 'd', val: "1101"  }, 
	  {    key: 'e', val: "1110"  }, {    key: 'f', val: "1111"  }
  ]

  let value = ""
  for (let i = 0; i < str.length; i++) {
    for (let j = 0; j < hex_array.length; j++) {
      if (str.charAt(i) == hex_array[j].key) {
        value = value.concat(hex_array[j].val)
        break
      }
    }
  }
  console.log(value)
  return value
}

//从url中截取api路径
function getApiPath(url) {
  if (url == null || url == "") {
    return url;
  }
  url = url.replace(/\/\//, "");
  url = url.substr(url.indexOf("/"));
  return url;
}


function isInArray(arr,d){
		for(var i=0;i<arr.length;i++){
			if(arr[i]==d){
				return true;
			}
		}
		return false;
	}
//数字转中文
function numberToCn(n){
	try{
		if(n==1)return "一";
		else if(n==2)return "二";
		else if(n==3)return "三";
		else if(n==4)return "四";
		else if(n==5)return "五";
		else if(n==6)return "六";
		else if(n==7)return "七";
		else if(n==8)return "八";
		else if(n==9)return "九";
		else if(n==0)return "十";
			
	}catch(e){
		alert("出错：" + e );
		
	}
	
}


function showShareMenu(){
	//#ifdef MP-WEIXIN
	try{
		wx.showShareMenu({
		  withShareTicket: true,
		  menus: ['shareAppMessage', 'shareTimeline']
		});
	}catch(e){
		console.log(e);
	}
	//#endif
}

function compareVersion(v1, v2) {
  v1 = v1.split('.')
  v2 = v2.split('.')
  var len = Math.max(v1.length, v2.length)

  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }

  for (var i = 0; i < len; i++) {
    var num1 = parseInt(v1[i])
    var num2 = parseInt(v2[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }
  return 0
}
function delHtmlTag(str){
	if(!!str==false)return str;
	return str.replace(/<[^>]*>/g,""); //正则去掉所有的html标记
}
/****************xs end*/

var eggsay_img={
	success:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAABnlBMVEUzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTMzmTPMqePfAAAAinRSTlMAGVuTut7u/t/BlhoVcMv/cR2Y9/vJnXdkVfgeB4D2qlEODYEs1PGFU/WhF1Zq/OxL/Wtp01TKESjz0hAP9OoceUhJeqKS8BYUhguMf0XNCI+RAalQH8+LYD9clPqmA8YGuyUF4XZeBLIwpCEJuWUg77PcjtlCnNeZGNXpEmFPGwJKV6AthE5j4OJ+lDZhAAAClklEQVRIx62W+UMSQRTHNxHWEPyGXCIEYioBCpSUhAgdumAHWdJJkpRY2X3RZVl51X/dLMuxy+yVtT8MM2/fh5158y6G+R/PoR5Dr9HEsqa+w+aefm19i3UAkmfgiEUVsA3aiZbD6XIPeTxDbpfTQZbDg15FwHfUTxQCI8GOaHQkMAz4j/nkibFxYCJEbcMSmgDGx+SI42Gwkajcm2iERXiSlk/FEE8obTkRx4mT3cJpIKl8SsabBKalolMxnJ5Rs+WMEzGPWJA6g/Ss+oVl0phLiaybRjandcm5LJIdW58Fe07bMc6zuNDmw5jX43zzCLf2sgAuqgfJc1gQZgU/FlVVL166LEwW4Recwwp7QY240tf+czusjUkRARXg6hKLa9ebi2UUGxcLlJSJGzeBW+1VCeBj7jYcQUXiThYwd5bBGO6SnzKcisTUPWClIhI4USZjL1wKQMVMYvL+qljkQpWMRrglig9ak4crhFiThlwNRjJyWBfJHi3BIHiS7zEh/E+kH14HR0ZWYrANPqk8JZNnz/n88qJrryWwFPLSSBRflZjV1zyxwcgi0o0x3jdElX3Lfw1rmW5E2Fj38XPvWlmPfU8ZUTh+FXWpuP9DE/lI210wMn2Vnz43iC+bNCJcpYzD5NM88pUmgo6Gw8i5ZYE4Y7pCI9+ALcH5l6l3m0VZ9246v3yIzUa+00Q7xEggh/QVq1ArkPl0YdFDWDgYOkkpogeJdJISn/p+aBMJUerjE2zcpkXY4uIEy6TmkM78VRpnmEk9xeLnv5akgxQ+obxu52XT97Z8eWWYHVLEuV26iO9ypIjvqLQK9sDeqKhV2AvYVVoF/pTNhqRe2/d49mt1zYbkQG1Ps7kqV3+ZANNvfc2VjucPCfdizoMxgXcAAAAASUVORK5CYII=",
	warn:"data:image/png;base64,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",
	loading:"data:image/gif;base64,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",
	aeonloadingbg:"data:image/png;base64,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",
	aeonloading:"data:image/png;base64,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",
}
var eggsay_alert_timeout=null;
window.alert = function(mess){
	if($('#eggsay_alert_id').length){
		$('#eggsay_alert_id').remove();
	}
	if(eggsay_alert_timeout!=null)clearTimeout(eggsay_alert_timeout);
	var windowHeight=$(window).height();
	$('body').append("<div id='eggsay_alert_id' class='eggsay_alert' style='position:fixed;z-index:9999;"
			+"top:"+(windowHeight/2-30)+"px;"
			+"left:0;right:0;margin:0 auto;max-width:160px;"
			+"padding:15px 10px;display:block;"
			+"color: #fff;background: #222;xxbox-shadow:0 0 4px #000;"
			+"text-align:center;border-radius:8px;'>"
			+mess
			+"</div>"
			);
    eggsay_alert_timeout=setTimeout(function(){$('#eggsay_alert_id').remove();},2000);
}

/**
 * showToast(Object object)
	显示消息提示框
	参数
	Object object
	属性 	类型 	默认值 	必填 	说明 	最低版本
	title 	string 		是 	提示的内容 	
	icon 	string 	'success,warn,none' 	否 	图标 	
	image 	string 		否 	自定义图标的本地路径，image 的优先级高于 icon 	1.1.0
	duration 	number 	1500 	否 	提示的延迟时间 	
	mask 	boolean 	false 	否 	是否显示透明蒙层，防止触摸穿透 	
	success 	function 		否 	接口调用成功的回调函数 	
	fail 	function 		否 	接口调用失败的回调函数 	
	complete 	function 		否 	接口调用结束的回调函数（调用成功、失败都会执行）
 */
var eggsay_toast_timeout=null;
window.showToast = function(obj){
	if($('#eggsay_toast_id').length){
		//return false;
		$('#eggsay_toast_id').remove();
	}
	if(eggsay_toast_timeout!=null)clearTimeout(eggsay_toast_timeout);
	var windowHeight=$(window).height();
	if(typeof obj.icon=="undefind" || obj.icon==null || obj.icon==""){
		obj.icon=eggsay_img.success;
	}
	if(obj.icon=='warn')obj.icon=eggsay_img.warn;
	$('body').append("<div id='eggsay_toast_id' class='eggsay_toast' style='position:fixed;z-index:10001;"
			+"top:"+(windowHeight/2-40)+"px;"
			+"left:0;right:0;margin:0 auto;max-width:160px;"
			+"padding:15px 10px;display:block;"
			+"color: #fff;background: #222;xxxbox-shadow:0 0 4px #000;"
			+"text-align:center;border-radius:5px;'>"
			+((obj.icon!="none")?"<img src='"+obj.icon+"' style='width:40px;display:block;margin:0 auto;'/>":"")
			+"<div style='padding-top:10px;color:#fff;'>"+obj.title+"</div>"
			+"</div>"
			);
    eggsay_toast_timeout=setTimeout(function(){$('#eggsay_toast_id').remove();},2000);
}


/**
 * 弹出对话
 * @param obj{name,callback,clickObj},也可多项array[{name,callback,clickObj}]
 * @icon object{img,name,callback} 可为null
 */	
window.alertDialog = function(obj,icon){
	if($('.eggsay_alert').length){
		$('.eggsay_alert').remove();
	}
	if(eggsay_alert_timeout!=null)clearTimeout(eggsay_alert_timeout);
	var windowHeight=$(window).height();
	var top=(windowHeight-150)/2;
	if(top<10)top=10;
	var html="<div class='eggsay_alert_bg eggsay_alert' style='width:100%;height:"+windowHeight+"px;background:#000;opacity:0.5;position:fixed;z-index:19998;top:0;left:0;'></div><div class='eggsay_alert' " 
		+"style='position:fixed;z-index:19999;top:"+top+"px;"
		+"left:0;right:0;margin:0 auto;width:65%;max-width:300px;"
		+"padding:20px 15px;display:block;"
		+"color: #fff;background: #fff;box-shadow:0 0 4px #666;"
		+"text-align:center;border-radius:5px !important;'>";
	if($.type(icon)!="undefined" && icon!=null && $.type(icon.img)!="undefined"){
		html+="<img class='eggsay_alert_icon' style='width:50px;margin:10px auto;display:block;' src='"+icon.img+"'/>";
		if($.type(icon.name)!="undefined" && icon.name!=null && icon.name!="" ){
			html+="<div style='margin:10px auto;color:#888;display:block;'>"+icon.name+"</div>";
		}
	}else{
		html+="<img style='width:50px;margin:10px auto;display:block;' src='"+eggsay_img.success+"'/>";
	}
	if($.type(obj)=="object"){
		html+="<div class='eggsay_alert_option' style='border-radius: 5px;margin: 5px;display:inline-block;padding:10px;background:#090;'>"+obj.name+"</div>";
	}else if($.type(obj)=="array"){
		for(var i=0;i<obj.length;i++){
			html+="<div class='eggsay_alert_option"+i+"' style='border-radius: 5px;margin: 5px;display:inline-block;padding:10px;background:#090;'>"+obj[i].name+"</div>";
		}
	}
	html+="<div class='eggsay_alert_close' style='border-radius: 5px;margin: 5px;display:inline-block;padding:10px;background:#090;'>关闭</div>";
	html+="</div>";
	$('body').append(html);
	
	//图标
	if($.type(icon)!="undefined" && icon!=null && $.type(icon.callback)!="undefined"){
		$('.eggsay_alert_icon').unbind("click").bind("click",function(){
			$('.eggsay_alert').remove();
			if(typeof icon.callback=="function"){icon.callback.call(this,icon.clickObj);}
			else if(typeof window[icon.callback]=="function"){window[icon.callback](icon.clickObj);}
		});
	}
	
	//按钮可为object或array
	if($.type(obj)=="object"){
		$('.eggsay_alert_option').unbind("click").bind("click",function(){
			$('.eggsay_alert').remove();
			if(typeof obj.callback=="function"){obj.callback.call(this,obj.clickObj);}
			else if(typeof window[obj.callback]=="function"){window[obj.callback](obj.clickObj);}
		});
	}else if($.type(obj)=="array"){
		for(var i=0;i<obj.length;i++){
			$('.eggsay_alert_option'+i).unbind("click").bind("click",{mObj:obj,i:i},function(event){
				$('.eggsay_alert').remove();
				//event.data.mObj[event.data.i].callback.call(this);
				if(typeof event.data.mObj[event.data.i].callback=="function"){event.data.mObj[event.data.i].callback.call(this,event.data.mObj[event.data.i].clickObj);}
				else if(typeof window[event.data.mObj[event.data.i]]=="function"){window[event.data.mObj[event.data.i]](event.data.mObj[event.data.i].clickObj);}
			});
		}
	}
	$('.eggsay_alert_bg').unbind("click").bind("click",function(){
		event.preventDefault();event.stopPropagation()
		$('.eggsay_alert').remove();
	});
	$('.eggsay_alert_close').unbind("click").bind("click",function(){
		$('.eggsay_alert').remove();
	});
}


/**
 * 弹出模态弹窗
 * @param obj{}
	title 	string 		否 	提示的标题
	content 	string 		否 	提示的内容
	contentAlign 	string 		否 	提示的内容
	contentFontSize string "00px|00rem"
	showCancel 	boolean 	true 	否 	是否显示取消按钮
	cancelText 	string 	'取消' 	否 	取消按钮的文字，最多 4 个字符
	cancelColor 	string 	#000000 	否 	取消按钮的文字颜色，必须是 16 进制格式的颜色字符串
	cancelBackground  string 	#576B95 
	confirmText 	string 	'确定' 	否 	确认按钮的文字，最多 4 个字符
	confirmColor 	string 	#576B95 	否 	确认按钮的文字颜色，必须是 16 进制格式的颜色字符串
	navText 	string 	'' 	否 	导航按钮的文字，最多 4 个字符
	navColor 	string 	#576B95 	否 	导航按钮的文字颜色，必须是 16 进制格式的颜色字符串
	navCallback 	function(res) 	否 	导航按钮的回调
	confirmBackground 	string 	#576B95 	否 	确认按钮的文字颜色，必须是 16 进制格式的颜色字符串
	isCanClickBackground boolean 背景是否可点击, 默认可以
	success 	function (res){boolean res.confirm,boolean res.cancel}		否 	接口调用成功的回调函数 
	fail 	function 		否 	接口调用失败的回调函数
	complete 	function 		否 	接口调用结束的回调函数（调用成功、失败都会执行）
	object.success 回调函数

	//实例
	window.showModal({
		title:"温馨提示",
		content:"恢复供货方改，回规格价格好几个，号或接口空间好看公爵黑卡",
		confirmColor:"#f00",
		showCancel:false,
		success:function(res){
			console.log(res);
			if(res.confirm){
				alert("确认");
			}else{
				alert("取消");
			}
		}
	});
 */	
window.showModal = function(obj){
	if($('.eggsay_modal').length){
		$('.eggsay_modal').remove();
	}
	var windowHeight=$(window).height();
	var top=(windowHeight-150)/2;
	if(top<10)top=10;
	var html="<div class='eggsay_modal_bg eggsay_modal' style='width:100%;height:"+windowHeight+"px;background:#000;opacity:0.5;position:fixed;z-index:19998;top:0;left:0;'></div><div class='eggsay_modal' " 
		+"style='position:fixed;z-index:19999;top:"+top+"px;"
		+"left:0;right:0;margin:0 auto;width:80%;max-width:300px;"
		+"padding:20px 15px;display:block;"
		+"color: #fff;background: #fff;box-shadow:0 0 4px #666;"
		+"text-align:center;border-radius:8px !important;'>";
	
	
	if($.type(obj)=="object"){
		if(typeof obj.contentAlign=="undefined" || obj.contentAlign==null || obj.contentAlign==""){
			obj.contentAlign="center";
		}
		if(typeof obj.confirmText=="undefined" || obj.confirmText==null || obj.confirmText==""){
			obj.confirmText="确定";
		}
		if(typeof obj.cancelText=="undefined" || obj.cancelText==null || obj.cancelText==""){
			obj.cancelText="取消";
		}
		if(typeof obj.cancelBackground=="undefined" || obj.cancelBackground==null || obj.cancelBackground==""){
			obj.cancelBackground="none";
		}
		if(typeof obj.confirmColor=="undefined" || obj.confirmColor==null || obj.confirmColor==""){
			obj.confirmColor="#000000";
		}
		if(typeof obj.confirmBackground=="undefined" || obj.confirmBackground==null || obj.confirmBackground==""){
			obj.confirmBackground="none";
		}
		if(typeof obj.navColor=="undefined" || obj.navColor==null || obj.navColor==""){
			obj.navColor="#000000";
		}
		var contentFontSize=(typeof obj.contentFontSize=="undefined" || obj.contentFontSize==null || obj.contentFontSize=="")?"":"font-size:"+obj.contentFontSize+";";
		html+="<div style='font-weight:bold;font-size:16px;'>"+obj.title+"</div>";
		html+="<div style='padding: 10px 0;font-size:13px;text-align:"+obj.contentAlign+";"+contentFontSize+"'>"+obj.content+"</div>";
		
		if(typeof obj.navText!="undefined" && obj.navText!=null &&  obj.navText!=""){
			html+="<div class='eggsay_modal_nav' style='padding:10px 0;width: 100%;display:block;text-align:center;color:"+obj.navColor+";'>"+obj.navText+"</div>";
		}
		
		html+="<div style='display:flex; flex-direction:row; align-items:center; justify-content:space-between;padding-top:10px;border-top:1px solid #eee;'>";
		if(typeof obj.showCancel=="undefined" || obj.showCancel!=false){
			html+="<div class='eggsay_modal_option' data-action='0' style='width: 45%;display:inline-block;border-right:1px solid #eee;'>"+obj.cancelText+"</div>";
			html+="<div class='eggsay_modal_option' data-action='1' style='width: 45%;display:inline-block;background:"+obj.confirmBackground+";color:"+obj.confirmColor+"'>"+obj.confirmText+"</div>";
		}else{
			html+="<div class='eggsay_modal_option' data-action='1' style='width: 45%;margin:0 auto;padding:5px;border-radius:2px;display:inline-block;background:"+obj.confirmBackground+";color:"+obj.confirmColor+"'>"+obj.confirmText+"</div>";
		}
		html+="</div>";
	}
	html+="</div>";

	$('.page_box').append(html);
	//按钮可为object或array
	if($.type(obj)=="object"){
		$('.eggsay_modal_option').unbind("click").bind("click",function(){
			$('.eggsay_modal').remove();
			var action=$(this).attr("data-action");
			var res={};
			if(action=="0"){
				res.cancel=true;
			}else{
				res.confirm=true;
			}
			if(typeof obj.success=="function"){obj.success.call(this,res);}
			else if(typeof window[obj.success]=="function"){window[obj.success](res);}
		});
		if($('.eggsay_modal_nav').length){
			$('.eggsay_modal_nav').unbind("click").bind("click",function(){
				//$('.eggsay_modal').remove();
				var res={};
				if(typeof obj.navCallback=="function"){obj.navCallback.call(this,res);}
				else if(typeof window[obj.navCallback]=="function"){window[obj.navCallback](res);}
			});
		}
	}
	$('.eggsay_modal_bg').unbind("click").bind("click",function(){
		event.preventDefault();event.stopPropagation()
		if(typeof obj.isCanClickBackground!="undefined" && obj.isCanClickBackground==false){
		}else{
			$('.eggsay_modal').remove();
		}
	});
}

/**
 * @param obj{
 * title 	string 		是 	提示的内容
	mask 	boolean 	false 	否 	是否显示透明蒙层，防止触摸穿透
	success 	function 		否 	接口调用成功的回调函数
	fail 	function 		否 	接口调用失败的回调函数
	complete 	function 		否 	接口调用结束的回调函数（调用成功、失败都会执行）
 * }
 */
window.showLoading=function(obj){
	if(typeof obj=="undefined" || obj==null){obj={};} 
	if(typeof obj.title=="undefined" || obj.title==null)obj.title="请稍等";
	$('body').append(
		'<div id="eggsay_my_loading" style="z-index:9999;position:fixed;left:0;right:0;padding:10px;text-align:center;border-radius:10px;top:45%;width:60%;max-width:160px;background:#000;;margin:0 auto;">'
		+'<img style="width:40px;height:40px;" src="'+eggsay_img.loading+'">'
		+'<div style="width:100%;color:#eee;height:auto;padding:5px;" >'+obj.title+'</div>'
		+'</div>'
		);
}
//永旺专用
window.showLoading2=function(obj){
	//return;
	if($('.eggsay_my_loading').length)$('.eggsay_my_loading').remove();
	if(typeof obj=="undefined" || obj==null){obj={};}
	if(typeof obj.title=="undefined" || obj.title==null)obj.title="请稍等";
	$('.page_box').append(
		'<div class="eggsay_my_loading" style="z-index:9999;position:fixed;left:0;right:0;text-align:center;top:45%;width:50px;margin:0 auto;">'
		+'<div style="position:relative;width:50px;height:50px;display:inline-block;">'
		+'<img style="left:0;top:0;position:absolute;width:50px;height:50px;" src="'+eggsay_img.aeonloadingbg+'">'
		+'<img style="animation:turn 1s linear infinite;left:0;top:0;position:absolute;width:50px;height:50px;" src="'+eggsay_img.aeonloading+'">'
		+'</div>'
		//+'<div style="width:100%;color:#eee;height:auto;padding:5px;" >'+obj.title+'</div>'
		+'</div>'
		);
}
window.hideLoading=function(){
	if($('.eggsay_my_loading').length)$('.eggsay_my_loading').remove();
}

window.log=function(msg){
	console.log(msg);
	return;
	if(typeof msg=="undefined" || msg==null)return;
	if(typeof msg=="object")msg=JSON.stringify(msg);
	msg=new Date().toLocaleTimeString()+" : "+msg
	if($('.eggsay_log').length==0){
		$('.page_box').append(
			'<div class="eggsay_log" style="word-break:break-all;font-size:13px;text-align:left;padding:10px 10px 50px 10px;width:100%;margin:10px auto;">'
			+'<div>'+msg+'</div>'
			+'</div>'
			);
	}else{
		$('.eggsay_log').append(
			'<div>'+msg+'</div>'
			);
	}
}


/**
 * 防抖
 */
window.canRun = true;
window.throttle = function(callback, time) {
  if (!window.canRun) {
	return;
  }
  window.canRun = false;
  setTimeout(function() {
	callback();
	window.canRun = true;
  }, time);
}




//input只能为正整数
window.checkNum=function(element) {
	var val= element.value;
	//匹配非数字
	var reg = new RegExp("([^0-9]*)","g");
	var ma = val.match(reg);
	//如果有非数字，替换成""
	if(ma.length>0){
		for(var k in ma){
			if(ma[k]!=""){
				val = val.replace(ma[k],"");
			}
		}
	}
	//可以为0，但不能以0开头
	if(val.startsWith("0")&&val.length>1){
		val = val.substring(1,val.length);
	}
	//赋值，这样实现的效果就是用户按下非数字不会有任何反应
	element.value = val;
}


/**
 * 调用APP原生方法(android,ios)
 * app初始化会在webview 环境注入jsbridge，注册以下方法给js 调用，调用过程中某些方法会有回调，
 * 其中 window.callNativePage 调用原生主方法，（此方法jsbridge 会注入到window对象）
 * @param options{option.method, option.data, option.callback}
 */
window._callNativePage= function(options) {
	var appEnv=window.localStorage.getItem('appEnv');//jsbridge_init时赋值
	if(appEnv!=null){
		var envObj=JSON.parse(appEnv);
		if(envObj.channel=="mp"){
			//调用微信
			callMpPage(options);
			return;
		}
	}

	//调用android,ios
	if (window.callNativePage) {
		if(typeof options!="undefined" && typeof options.data!="undefined" && typeof options.data.vueObj!="undefined" )options.data.vueObj=null;//清除
		window.callNativePage(options);
	}
	
};


/**
 * 调用小程序api
 */ 
var callMpPage=function(options){
	if(options.method=='scanCode'){
		doScanCode(options);//扫码
	}
	else if(options.method=='goback'){
		if(options.data && options.data.vueObj){
			try{options.data.vueObj.$router.back();}catch(e){console.log(e);}
		}else{
			wx.miniProgram.navigateBack();
		}
	}
	else if(options.method=='goback_n'){ 
		wx.miniProgram.navigateBack();
	}
	else if(options.method=='callToast'){ 
		if(options.data && options.data.type && options.data.type==5){
			/**
			 * type: 0, //  type 1：success 2：error 3：warning 4：info 5：loading
			 * message: '123',
			 * hide: 0, // 0：显示  1：隐藏
			 */
			if(options.data.hide && options.data.hide==0){
				window.showLoading2();
			}else{
				window.hideLoading();
			}
			
		 }		 
	}
	else if( options.method=='giftCardPayCancelled'){
		var orderNo=options.data.orderNo;
		if(typeof options.data.system!='undefined' && options.data.system=='scanbuy'){
			//判断传入的system参数，如果 system =scanbuy，
			wx.miniProgram.navigateTo({
				url: '/scanbuy/pages/orderDetail/orderDetail?orderNo='+orderNo+'&orderType=1',
				success(res) {},
				fail(res) {},
				complete(res) {}
				});

		}else if(typeof options.data.system!='undefined' && options.data.system=='delivery'){
			//system=delivery，则
			wx.miniProgram.navigateTo({
				url: '/delivery/pages/orderDetail/orderDetail?orderNo='+orderNo,
				success(res) {},
				fail(res) {},
				complete(res) {}
				});
		}else{
			if(typeof options.data.vueObj!='undefined'){
				try{options.data.vueObj.$router.back();}catch(e){console.log(e);}
			}
		}
		
	
	}
	else if(options.method=='setPageTitle'){
		//alert(options.data.pageTitle);
		//document.title = options.data.pageTitle;
	}
	else if(options.method=='setData_n'){
		
		wx.miniProgram.postMessage({ data:  options.data });
	}
	else if(options.method=='goLogin'){
		try{
			var path=typeof options.data.path!="undefined"?options.data.path:"";
			wx.miniProgram.navigateTo({
				url:"/public/pages/auth/auth?from=ecard&path="+path,
				success:function(res){},
				fail:function(res){}
				});
		}catch(e){alert(e)}
		
	}
	else if(options.method=='payForBuyCard'){
		try{
			wx.miniProgram.navigateTo({
				url:"/ecard/pages/ecardPay/ecardPay?orderNo="+options.data.orderNo+"&payType=1",
				success:function(res){},
				fail:function(res){}
				});
		}catch(e){alert(e)}
		
	}
	else if(options.method=='payForUseCard'){
		try{
			var storeCode=localStorage.getItem("storeCode") || "";
			wx.miniProgram.redirectTo({
				url:"/ecard/pages/ecardPay/ecardPay?orderNo="+options.data.orderNo+"&payType=2&storeCode="+storeCode+"&system="+options.data.system,
				success:function(res){},
				fail:function(res){}
				});
		}catch(e){alert(e)}
		
	}
	// 发票页面 //linkpid: 10000002, 
	else if(options.method=='redirectTo' && typeof options.data.linkpid!="undefined" && options.data.linkpid==10000002){
		if(typeof options.data.action!="undefined" && options.data.action==2){
			// window.log("开启小程序开票 /ecard/pages/ecardInvoice/ecardInvoice?channel=ecard&type=2&orderSource=2&outOrderNo="+options.data.outOrderNo);
			// 小程序补开发票
			wx.miniProgram.navigateTo({
				url: '/ecard/pages/ecardInvoice/ecardInvoice?channel=ecard&type=2&orderSource=2&outOrderNo='+options.data.outOrderNo,
				success(res) {},
				fail(res) {},
				complete(res) {}
			  });

		}else{

			//选票抬头
			//window.location.href="http://192.168.43.102:8080/qytcmapi/content/view/detail?id=30";//";return;
			try{
				var f=options.data.f?"&f="+options.data.f:"";
				if(options.data.invoiceId)f+="&id="+options.data.invoiceId;
				wx.miniProgram.navigateTo({
					url:"/ecard/pages/ecardInvoice/ecardInvoice?channel=ecard"+f,
					success:function(res){},
					fail:function(res){}
					});
			}catch(e){alert(e)}
		}
	}

	// 去购物页面 //linkpid: 10000001,
	else if(options.method=='redirectTo' && typeof options.data.linkpid!="undefined" && options.data.linkpid==10000001){
		try{
			window.log("去购物页面");
			wx.miniProgram.switchTab({
				url:"/home/pages/index/index",
				success:function(res){},
				fail:function(res){}
				});
		}catch(e){alert(e)}
	}
	else if(options.method=='getCurrStoreCode'){
		var storeCode=window.localStorage.getItem("storeCode")||"";
		if(typeof storeCode=="undefined" && storeCode==null){
			storeCode="";
		}
		//有定义则回调
		if(typeof options.callback=="function"){
			options.callback({storeCode:storeCode});
		}
	}
	else if(options.method=='shareByWechat'){
		wx.miniProgram.navigateTo({
			url: options.data.url,
			success(res) {},
			fail(res) {},
			complete(res) {}
		});
	}

}


/**
 * 小程序扫码
 */
var doScanCode=function(options){
	
	//是否已授权
	var wxauthurlForScanQRCode=window.sessionStorage.getItem("wxauthurlForScanQRCode")||"";
	if(typeof wxauthurlForScanQRCode=="undefined" || wxauthurlForScanQRCode==null )wxauthurlForScanQRCode=""; 
	var authUrl=window.location.href;
	if(wxauthurlForScanQRCode!="" && wxauthurlForScanQRCode.indexOf(authUrl+";")>=0){
		window.log("开始扫码...");
		//直接扫码
		wx.scanQRCode({
			needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
			scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
			success: function (res) {
				var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
				//尝试ios差异处理：{"scan_code":{"scan_type":"qrcode","scan_result":"8496668311"}}
				try{
					if(typeof result=="string" && result!=null && result.indexOf("scan_result")>0){
						var iosObj=JSON.parse(result);
						if(iosObj.scan_code && iosObj.scan_code.scan_result ){
							result=iosObj.scan_code.scan_result;
						}
					}else if(typeof result=="object" && result.scan_code && result.scan_code.scan_result){
						result=result.scan_code.scan_result;
					}
				}catch(e){
					window.log(e);
				}
				if(result && typeof options.callback=="function"){
					options.callback({value:result});
				}
			},
			fail:function (res) {
				window.log(res);
				window.sessionStorage.removeItem("wxauthurlForScanQRCode");
			}
		});
		return;
	}
	

	//未授权，开始请求
	try{
		window.showLoading();
		options.data.vueObj.$axios.request({
			url: '/member/getPosition',
			data: {
				url: window.location.href,
			}
		}).then(response => {
			window.hideLoading();
			if(response && response.data && response.data.code==0){
				const { appId, nonceStr, signature, timestamp } = response.data.data;
				try{
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: appId, // 必填，公众号的唯一标识
						timestamp:(typeof timestamp=="string"?parseInt(timestamp):timestamp), // 必填，生成签名的时间戳
						nonceStr: nonceStr, // 必填，生成签名的随机串
						signature: signature.toLocaleLowerCase(),// 必填，签名
						jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
					});
					wx.ready(function(){

						window.sessionStorage.setItem("wxauthurlForScanQRCode",wxauthurlForScanQRCode+authUrl+";");//记录授权

						// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
						wx.scanQRCode({
							needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
							scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
							success: function (res) {
								
								var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果

								//尝试ios差异处理：{"scan_code":{"scan_type":"qrcode","scan_result":"8496668311"}}
								try{
									if(typeof result=="string" && result!=null && result.indexOf("scan_result")>0){
										var iosObj=JSON.parse(result);
										if(iosObj.scan_code && iosObj.scan_code.scan_result ){
											result=iosObj.scan_code.scan_result;
										}
									}else if(typeof result=="object" && result.scan_code && result.scan_code.scan_result){
										result=result.scan_code.scan_result;
									}
								}catch(e){
									window.log(e);
								}
								
								if(result && typeof options.callback=="function"){
									options.callback({value:result});
								}
							},
							fail:function (res) {
								window.log(res);
								window.sessionStorage.removeItem("wxauthurlForScanQRCode");
							}
						});

					});
					wx.error(function(res){
						// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。

					});
				}catch(e){
					window.log(e);
				}
			}
			
		});
	}catch(e){window.log(e);window.hideLoading();}
}

/**
 * 仅获取： phone, nick_name, photo, money, coupon, consume_amount, jifen 
 */
var getUserInfo=function(vueObj,callback) {
	console.log("查询用户");
	var that = this;
	var user = window.$utils.uniapi.getStorageSync("user") || {};
	if (user == null || typeof user.id == "undefined") {
		console.log("无uid");
		return;
	}
	var params = {};
	vueObj.$axios.request({
		url: window.$config.url.getUserInfo,
		data: params
		})
		.then(res => {
		console.info(">>>>>>>>> getUserInfo ", res.data);
		if (!!res.code == true && res.code ==   window.$config.resCode.SUCCESS) {
			var user_new= Object.assign(user, res.data);
			window.$utils.uniapi.setStorageSync("user", user_new);
			if (typeof callback == "function") { callback(user_new); }
		}
	});
}
/**
 * 是否为微信浏览器，h5支付因支付宝不支持微信，需跳出
 */
var isInWeixin=function() {
	// #ifdef H5
	const ua = window.navigator.userAgent.toLowerCase();
	return ua.indexOf('micromessenger') !== -1;
	// #endif
	// return false;
	
}


/**
 * 数据输出
 */
export default {
   
    /**
     * @return int 微信小程序:1,android:2,ios:3
     */
    getEnv: function () {
        //微信小程序
		var appEnv=window.localStorage.getItem('appEnv');//jsbridge_init时赋值
		if(appEnv!=null){
			var envObj=JSON.parse(appEnv);
			if(envObj.channel=="mp"){
				return 1;
			}
		}
        //if (typeof wx!="undefined" && wx.miniProgram) return 1;
        //if (/micromessenger/.test(ua)) return 1;
        let ua = window.navigator.userAgent;
        //android终端
        if (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) return 2;
        //ios终端
        else if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
            || /(iPhone|iPad|iPod|iOS)/i.test(ua)
        ) {
            return 3;
        }
        return 0;
	},
	

	/*xs start*/
	dateUtils: dateUtils,
	delHtmlTag:delHtmlTag,
	showShareMenu:showShareMenu,
	isInArray,
	uniapi,

	getUserInfo,
	isInWeixin


    
    

}





// WEBPACK FOOTER //
// ./src/utils/utils.js